import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
  ObjectValueAccessor,
} from 'src/app/shared/widgets/value-accessors/object-value-accessor';

@Component({
  selector: 'wl-profile-edit-notes',
  templateUrl: './profile-edit-notes.component.html',
  styleUrls: ['./profile-edit-notes.component.less'],
  providers: [CreateObjectValueAccessorProvider(ProfileEditNotesComponent), CreateObjectValueValidationProvider(ProfileEditNotesComponent)],
    standalone: false
})
export class ProfileEditNotesComponent extends ObjectValueAccessor<string> implements OnInit, OnChanges {
  @Input() profileId: number;

  constructor(private _profileService: ProfileService) {
    super('', true);
  }

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.profileId > 0) {
      this._profileService.getProfileNotes(this.profileId, true).then((data) => {
        this.value = data;
        this.setPristine();
      });
    }
  }

  public save(): Promise<void> {
    if (this.profileId > 0) {
      return this._profileService.upsertProfileNotes(this.profileId, this.value).then(() => {
        this.setPristine();
      });
    } else {
      return Promise.resolve<void>(null);
    }
  }
}
